import api from './axiosInstance';

const FALLBACK_TIMEZONE = 'America/Santiago';
const DEFAULT_MAX_ROWS = 120;
const MAX_ALLOWED_ROWS = 500;

const CANDIDATE_ENDPOINTS = [
  '/Marketing365/run',
  '/Marketing365/Run',
  '/Reports/run',
  '/Reports/Run',
  '/run',
];

const normalizeMaxRows = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return DEFAULT_MAX_ROWS;
  return Math.min(MAX_ALLOWED_ROWS, Math.max(1, Math.floor(parsed)));
};

export const getSacTranscripts = async (
  {
    dateFrom,
    dateTo,
    feeling,
    maxRows = DEFAULT_MAX_ROWS,
    excludeOmittedAudio = true,
  } = {},
  signal
) => {
  const params = {};

  if (typeof dateFrom === 'string' && dateFrom.trim()) {
    params.dateFrom = dateFrom.trim();
  }
  if (typeof dateTo === 'string' && dateTo.trim()) {
    params.dateTo = dateTo.trim();
  }
  if (typeof feeling === 'string' && feeling.trim()) {
    params.feeling = feeling.trim();
  }

  params.maxRows = normalizeMaxRows(maxRows);
  params.excludeOmittedAudio = excludeOmittedAudio !== false;

  const response = await api.get('/Marketing365/sac-transcripts', {
    params,
    signal,
  });

  return response.data;
};

export const getSacTranscriptById = async (id, signal) => {
  const parsedId = Number(id);
  if (!Number.isFinite(parsedId) || parsedId <= 0) {
    const error = new Error('ID de transcripción no válido');
    error.customMessage = 'ID de transcripción no válido';
    throw error;
  }

  const response = await api.get(
    `/Marketing365/sac-transcripts/${Math.floor(parsedId)}`,
    {
      signal,
    }
  );

  return response.data;
};

export const analyzeSacTranscripts = async (
  { transcriptIds = [], steps = [], excludeOmittedAudio = true } = {},
  signal
) => {
  const response = await api.post(
    '/Marketing365/GeneralMarketingAnalisis',
    { transcriptIds, steps, excludeOmittedAudio },
    { signal }
  );

  return response.data;
};

export const runMarketingReport = async (
  { userPrompt, timeZoneId, maxRows },
  signal
) => {
  const payload = {
    userPrompt: String(userPrompt || '').trim(),
    timeZoneId: String(timeZoneId || FALLBACK_TIMEZONE).trim() || FALLBACK_TIMEZONE,
    maxRows: normalizeMaxRows(maxRows),
  };

  let lastError = null;

  for (const endpoint of CANDIDATE_ENDPOINTS) {
    try {
      const response = await api.post(endpoint, payload, { signal });
      return response.data;
    } catch (error) {
      if (error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError') {
        throw error;
      }

      const status = error?.response?.status;
      if (status !== 404) {
        throw error;
      }

      lastError = error;
    }
  }

  throw lastError || new Error('No se encontró endpoint /Marketing365/run');
};

export default runMarketingReport;
